import type { AdminSuretyBond } from "@portal/api/bond/admin";
import { MetricCard } from "@portal/components/patterns/metric-card";
import { Card, Text } from "@portal/components/primitives";
import type { FC } from "react";
import { bondHeaderTermMetrics } from "../../../shared/bond/bondHeaderTerms";

export const AdminBondTermsCard: FC<{ bond: AdminSuretyBond }> = ({ bond }) => (
	<Card elevation="raised" className="rounded-xl" data-testid="admin-bond-terms-card">
		<Card.Header className="border-b-0 px-6 pt-6 pb-0">
			<Text type="title" color="primary">
				Bond Terms
			</Text>
		</Card.Header>
		<Card.Body className="px-6 pt-5 pb-6">
			<div className="flex flex-wrap gap-4">
				{bondHeaderTermMetrics(bond).map(({ label, value }) => (
					<MetricCard key={label} className="min-w-[9rem] flex-1 p-4">
						<MetricCard.Label size="md">{label}</MetricCard.Label>
						<MetricCard.Value size="md" className="mt-auto whitespace-nowrap">
							{value}
						</MetricCard.Value>
					</MetricCard>
				))}
			</div>
		</Card.Body>
	</Card>
);
